export default __webpack_public_path__ + "static/media/collapse_black_arrow.fa6ad5ad.svg";